import { Injectable } from '@angular/core';
import { AnalyticsService } from 'smartauction-frontend-micro-library';
import { Notification } from 'remarketing-angular-library';

export interface AlertTrackingConfig {
  buyAlerts: Array<Notification>;
  sellAlerts: Array<Notification>;
  showSellerAlerts: boolean;
  formName: string;
  checkVisibility: (alert: any) => boolean;
  getAlertDescription: (alert: any) => string;
  checked: (type: string) => boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AlertTrackingService {
  constructor(private analyticsService: AnalyticsService) {}

  createConfigForAccordion(
    accordion: 'Buy' | 'Sell',
    buyAlerts: Array<Notification>,
    sellAlerts: Array<Notification>,
    checkVisibility: (alert: any) => boolean,
    getAlertDescription: (alert: any) => string,
    checked: (type: string) => boolean
  ): AlertTrackingConfig {
    return {
      buyAlerts: accordion === 'Buy' ? buyAlerts : [],
      sellAlerts: accordion === 'Sell' ? sellAlerts : [],
      showSellerAlerts: accordion === 'Sell',
      formName: accordion === 'Buy' ? 'Buy Alerts and Notifications' : 'Sell Alerts and Notifications',
      checkVisibility,
      getAlertDescription,
      checked
    };
  }

  createConfigForBuyersAndOtherRecipients(
    formName: string,
    buyAlerts: Array<Notification>,
    sellAlerts: Array<Notification>,
    showSellerAlerts: boolean,
    checkVisibility: (alert: any) => boolean,
    getAlertDescription: (alert: any) => string,
    checked: (type: string) => boolean
  ): AlertTrackingConfig {
    return {
      buyAlerts,
      sellAlerts,
      showSellerAlerts,
      formName,
      checkVisibility,
      getAlertDescription,
      checked
    };
  }

  trackAlertPreferences(config: AlertTrackingConfig, isSuccess: boolean): void {
    const checkboxValues: any[] = [];

    config.buyAlerts
      .filter(alert => config.checkVisibility(alert))
      .forEach(alert => {
        checkboxValues.push({
          track: 'yes',
          name: `Buy - ${config.getAlertDescription(alert)}`,
          value: config.checked(alert.type) ? 'checked' : 'unchecked',
          isPII: 'false'
        });
      });

    config.sellAlerts
      .filter(alert => config.checkVisibility(alert))
      .forEach(alert => {
        checkboxValues.push({
          track: 'yes',
          name: `Sell - ${config.getAlertDescription(alert)}`,
          value: config.checked(alert.type) ? 'checked' : 'unchecked',
          isPII: 'false'
        });
      });

    this.analyticsService.track(
      'customEvent',
      this.analyticsService.formSubmit(
        isSuccess ? 'formSuccess' : 'formError',
        isSuccess ? 'formValidationSuccess' : 'formValidationError',
        config.formName,
        checkboxValues,
        isSuccess ? '' : 'Failed to save alert preferences'
      )
    );
  }
}
